import ModeloManagementPage from '../pages/ModeloManagementPage'

const routes = [
    { name: 'ModeloManagementPage', path: '/modelo-management', component: ModeloManagementPage },
]

export default routes;
